// extracted by mini-css-extract-plugin
export default {"CommentBox":"Shared-module__CommentBox--x3rre","Condensed":"Shared-module__Condensed--p_BOv"};